import { render, staticRenderFns } from "./ToggleAutoKeyCollection.vue?vue&type=template&id=5569b9fb&scoped=true"
import script from "./ToggleAutoKeyCollection.vue?vue&type=script&lang=js"
export * from "./ToggleAutoKeyCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5569b9fb",
  null
  
)

export default component.exports